// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"f695074a","449":"f615ed70","482":"5516a71f","851":"3bed1c47"}[chunkId] + ".chunk.js";
};